import * as React from "react";
import { WarningIcon } from "affinityIcons";
import { styled } from "styled-components";

const ResultWrapContainer = styled.div<{ $warning?: boolean }>`
  font-weight: bold;
  width: fit-content;
  color: ${({ $warning, theme }) => ($warning ? theme.colours.orange[500] : "inherited")};
`;

export const ResultWrap: React.FC<
  React.ComponentProps<typeof ResultWrapContainer> & React.PropsWithChildren<{ warning?: boolean }>
> = ({ children, warning, ...props }) => (
  <ResultWrapContainer $warning={warning} {...props}>
    {children} {warning ? <WarningIcon /> : <></>}
  </ResultWrapContainer>
);
